import React from 'react';
import { Badge, Avatar } from '@mui/material';
import PropTypes from 'prop-types';

const ChatUserProfilePicture = ({
  image,
  isOnline,
  name,
  size,
  displayIsOnline,
}) => (
  <Badge
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    overlap="circular"
    color={isOnline ? 'success' : 'error'}
    variant="dot"
    badgeContent={displayIsOnline ? 1 : 0}
  >
    <Avatar src={image} sx={{ width: size, height: size }}>
      {/* get initial letter of the first two names in uppercase */}
      {name.split(' ')
        .slice(0, 2)
        .map((part) => part[0])
        .join('')
        .toUpperCase()}
    </Avatar>
  </Badge>
);

ChatUserProfilePicture.propTypes = {
  image: PropTypes.string,
  isOnline: PropTypes.bool,
  name: PropTypes.string,
  size: PropTypes.number,
  displayIsOnline: PropTypes.bool,
};

ChatUserProfilePicture.defaultProps = {
  image: '',
  name: '',
  isOnline: false,
  size: 36,
  displayIsOnline: true,
};

export default ChatUserProfilePicture;
